import { UiSuspensefulOutlet } from '@experiences/ui-common';
import React from 'react';

import { routePaths } from '../../../common/constants/routePaths';
import type { UiRouteObject } from '../../../container/routeConfigs/UiRouteObject';

const AutomationSuiteHealthComponent = React.lazy(() => import('./ClusterHealthPortalComponent'));

export const HostClusterHealthPortalRoutes: UiRouteObject = {
    path: routePaths.adminHostASPortal,
    element: <UiSuspensefulOutlet />,
    children: [
        {
            index: true,
            element: <AutomationSuiteHealthComponent />,
        },
    ],
};
